import OrderPickupDetails from './OrderPickupDetails'

export default OrderPickupDetails
